import axios from "axios";
import { environment } from "../../../environments/environment";

export function getTimeControls(part) {
    return axios.post(`${environment.getTimeControls}?page=0&pageSize=200`,[{"columnName": "partId", value: part.id}, {"columnName": "companyId", value: parseInt(localStorage.getItem('u_company_id'))}]);
}

export function getTimeControl(control){
    return axios.get(`${environment.getTimeControl}?id=${control.id}`)
}

export function getSpecificOverrides(control) {
    return axios.post(`${environment.getSpecificOverrides}`,[
        {"columnName": "etControlId", "value": control.id}, {"columnName": "companyId", value: parseInt(localStorage.getItem('u_company_id'))}
    ])
}


export function saveTimeControl(control) {
    let isUpdate = typeof (control.id) === "number";
    let companyId = localStorage.getItem('u_company_id');
    return axios.request({ url: environment.saveTimeControl, method: isUpdate ? "PUT" : "POST", data: {...control, companyId: parseInt(companyId)} })
}

export function saveOverride(ovr) {
    let isUpdate = typeof (ovr.id) === "number";
    let companyId = localStorage.getItem('u_company_id');
    return axios.request({ url: environment.saveOverride, method: isUpdate ? "PUT" : "POST", data: {...ovr, companyId: parseInt(companyId)} })
}

export function getSpecificOvr(ovrId){
    return axios.get(`${environment.getOverride}?id=${ovrId}`)
}

export function removeControl(controlId) {
    return axios.delete(`${environment.deleteTimeControl}?id=${controlId}`)
}

export function removeOverride(ovrId) {
    return axios.delete(`${environment.deleteOverride}?id=${ovrId}`)
}

export function getTimeControlInfo(control){
    return axios.get(`${environment.getTimeControl}?id=${control.id}`);
}